/**
 * PC_TG_01
 * Importing the component, API and packages
 */
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Popup from '../../components/ConformationPopup/Popup';
import EvaluationPopUp from '../../components/EvaluationPopUp';
import { deleteTouchbase, getTouchbase } from '../../service/PerformanceAPI';
import Loader from '../../StaticComponent/Loader';
import './Touchbase.css';
import $ from 'jquery';
import { encryptStorage } from '../../constant';

export default function Touchbase(props) {
    const navigate = useNavigate();
    const { state, search } = useLocation();
    /**
     * PC_TG_02
     * State variables are created
     */
    let details = { role: '', roleId: '', week: 0, domain: '' };
    const filterData = { filterStatus: '', filterFromDate: '', filterToDate: '' };
    const [filter, setFilter] = useState(filterData);
    const [touchbase, setTouchbase] = useState({});
    const [userDetails, setUserDetails] = useState(details);
    const [nodata, setNoData] = useState(false);
    const [showMore, setShowMore] = useState(true);
    const [TouchbaseShowMore, setTouchbaseShowMore] = useState(10);
    const [filterCheck, setFilterCheck] = useState(false);
    const [popUp, setPopUp] = useState(false);
    const [touchbaseId, setTouchbaseId] = useState();
    const [week, setWeek] = useState(0);
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [View, setView] = useState();
    const [IsTeamMember, setIsTeamMember] = useState(false);
    const [insertToast, setinsertToast] = useState(false);
    const [ToastColor, setToastColor] = useState('');
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');

    /**
     * PC_TG_03
     * useEffect is invoked and role is defined then loadTouchbaseData function is called
     */

    useEffect(() => {
        //
        let toastCheck = sessionStorage.getItem('touchbaseToast');

        // if (toastCheck == 'inserted' || toastCheck == 'updated') {
        //     setTimeout(() => {
        //         if (toastCheck == 'inserted') setinsertToast(true)
        //         if (toastCheck == 'updated') setupdateToast(true)
        //         sessionStorage.removeItem('touchbaseToast')
        //     }, 2500);
        // }

        if (toastCheck == 'inserted' || toastCheck == 'updated') {
            // setTimeout(() => {Heading={'Successfully  Scheduled'} Paragraph={'Touchbase is scheduled'}

            setToastColor('green');
            if (toastCheck == 'inserted') {
                setToastPara('Touchbase is scheduled');
                setToastValue('Successfully  Scheduled');
            }
            if (toastCheck == 'updated') {
                setToastValue('Successfully  Rescheduled');
                setToastPara('Touchbase is rescheduled');
            }
            setinsertToast(true);
            sessionStorage.removeItem('touchbaseToast');
            // }, 2000)
        }

        setIsLoading(false);
        if (props?.EmployeeId !== undefined && props?.EmployeeId !== null && props?.Domain !== undefined && props?.Domain !== null) {
            userDetails.roleId = props?.EmployeeId;
            userDetails.role = encryptStorage.getItem('role') === 'Hr' ? 'Hr Manager' : encryptStorage.getItem('role');
            // userDetails.role = encryptStorage.getItem('role')
            userDetails.domain = props?.Domain;
            setUserDetails({ ...userDetails });
            if (props?.View) {
                setView(true);
            }
            if (props.IsTeamMember == 'true') {
                setIsTeamMember(true);
            }
        } else {
            userDetails.roleId = encryptStorage.getItem('employeeId');
            userDetails.role = encryptStorage.getItem('role') === 'Hr' ? 'Hr Manager' : encryptStorage.getItem('role');
            // userDetails.role = encryptStorage.getItem('role');
            userDetails.domain = encryptStorage.getItem('department');
            setUserDetails({ ...userDetails });
        }

        setbreadCrumbsData(
            userDetails.role == 'Team Member'
                ? [
                    { title: 'Dashboard', path: '/Overview', isActive: true },
                    { title: 'My Performance', path: '/touchbase', isActive: true },
                    { title: 'Touchbase', path: '/touchbase', isActive: false },
                ]
                : [
                    { title: 'Dashboard', path: '/Overview?tab=activities', isActive: true },
                    { title: 'Team Member', path: '/touchbase', isActive: true },
                    { title: 'Touchbase', path: '/touchbase', isActive: false },
                ]
        );

        loadTouchbaseData();
    }, []);

    const infoForShowMore = (countResult, countToDivid) => {
        let count = countResult;
        let result = count / countToDivid;
        setShowMore(result == 1 || result < 1 ? false : true);
    };

    /**
     * PC_TG_04
     * useEffect is invoked and role is defined then loadTouchbaseData function is called
     */
    const loadTouchbaseData = async () => {
        let touchbase_Data = {
            employeeId: userDetails.roleId,
            limit: TouchbaseShowMore,
            domain: userDetails.domain,
        };
        //
        let touchbaseResult = await getTouchbase(touchbase_Data);

        setTouchbase(touchbaseResult.data.ResponseData !== 'No data found' ? touchbaseResult.data.ResponseData : []);

        let noDataValue = touchbaseResult.data.ResponseData.length == 0 ? true : false;
        setNoData(noDataValue);
        if (noDataValue) {
            setShowMore(false);
        } else {
            infoForShowMore(touchbaseResult.data.countResult, TouchbaseShowMore);
        }
        setIsLoading(true);
    };

    const newTouchbase = (type) => {
        View
            ? navigate('/touchbaseform', {
                state: {
                    touchbase: type,
                    View: true,
                    redirect: search,
                    employeeName: props?.EmployeeName,
                    employeeId: type == 'individual' ? props?.EmployeeId : '',
                },
            })
            : navigate('/touchbaseform', { state: { touchbase: type } });
    };
    /**
     * PC_TG_13
     * @param {*} type touchbaseform is redirected when user clicks a touchbase edit
     */
    const touchbaseEditClicked = async (touchbaseId, type) => {
        View
            ? navigate(`/touchbaseform/${touchbaseId}`, { state: { touchbase: type, View: true, redirect: search } })
            : navigate(`/touchbaseform/${touchbaseId}`, { state: { touchbase: type } });
    };

    /**
     * PC_TG_15,PC_TG_16
     * touchbaseDeleteClicked function is invoked when delete button is clicked
     * deleteTouchbase function is called to delete the touchbase
     * loadTouchbaseData function invoked after successfull response from backend
     */
    const touchbaseDeleteClicked = async (value) => {
        let touchbaseData = {
            touchbaseId: touchbaseId,
        };

        let templateInfo = await deleteTouchbase(touchbaseData);

        if (templateInfo.data.ResponseData.Message == 'Successfully deleted') {
            setPopUp(false);
            loadTouchbaseData();
        } else {
            setPopUp(false);
        }
    };

    const filterOnChange = (e) => {
        setFilter({ ...filter, [e.target.name]: e.target.value });
    };

    /**
     * PC_TG_22
     * UserClicks filter clear in filter button
     * filter data is set to empty
     */
    const touchbaseClearClick = () => {
        setFilter(filterData);
        loadTouchbaseData();
    };

    /**
     * PC_TG_23
     * UserClicks apply filter button in filter button
     * getTouchbase function is called response is set to state variable
     */
    const touchbaseFilterClick = async () => {
        setIsLoading(false);
        setTouchbaseShowMore(10);
        let filterCount = 10;
        let obj = {
            employeeId: userDetails.roleId,
            filterFromDate: filter.filterFromDate,
            filterToDate: filter.filterToDate,
            filterStatus: filter.filterStatus,
            // week: 0,
            limit: filterCount,
            domain: userDetails.domain,
        };

        setFilterCheck(true);
        let Response = await getTouchbase(obj);

        if (Object.keys(Response?.data.ResponseData).length > 0) {
            setTouchbase(Response.data.ResponseData);
        }
        let noDataValue = Response.data.ResponseData.length === 0 ? true : false;
        setNoData(noDataValue);
        if (noDataValue) {
            setShowMore(false);
        } else {
            infoForShowMore(Response.data.countResult, filterCount);
        }
        setIsLoading(true);

        // appreciationClearClick()
    };

    /**
     * PC_TG_24 when user clicks show more button
     * getTouchbase function is invoked filterdata/userdetails is passed as parameter
     * to retrieve the touchbase
     */
    const touchbaseShowMore = async () => {
        setIsLoading(false);
        if (filterCheck) {
            ////
            let filterCount = TouchbaseShowMore;
            filterCount += 10;
            let obj = {
                employeeId: userDetails.roleId,
                filterFromDate: filter.filterFromDate,
                filterToDate: filter.filterToDate,
                filterStatus: filter.filterStatus,
                // week: 0,
                limit: filterCount,
                domain: userDetails.domain,
            };
            setTouchbaseShowMore(filterCount);
            let response = await getTouchbase(obj);

            if (Object.keys(response?.data?.ResponseData).length > 0) {
                setTouchbase(response.data.ResponseData);
            }
            let noDataValue = Object.keys(response?.data?.ResponseData).length === 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data?.countResult, filterCount);
            }
        } else {
            ////
            let loadData = TouchbaseShowMore + 10;
            setTouchbaseShowMore(loadData);
            let obj = {
                employeeId: userDetails.roleId,
                // week: 2,
                domain: userDetails.domain,
                limit: loadData,
            };
            let response = await getTouchbase(obj);

            setTouchbase(response.data.ResponseData != 'No data found' ? response.data.ResponseData : null);
            if (Object.keys(response?.data.ResponseData).length > 0) {
                setTouchbase(response.data.ResponseData);
            }
            let noDataValue = response.data.ResponseData.length === 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data.countResult, loadData);
            }
        }
        setIsLoading(true);
    };
    /**
     * PC_TG_13
     * @param {*} id - touchabaseID is passed as parameter and using naviagte touchbaseFeedback form page is called
     */
    const touchbaseFeedback = (id) => {
        View ? navigate(`/touchbasefeedback/${id}`, { state: { View: true, redirect: search } }) : navigate(`/touchbasefeedback/${id}`);
    };

    const bindTouchbase = (Touchbase, date) => {
        return Touchbase?.map((eachTouchbase, i) => {
            let customstyle =
                eachTouchbase.type === 'team'
                    ? {}
                    : eachTouchbase.attendeeName?.includes('+ 1')
                        ? { 'margin-left': '40px' }
                        : eachTouchbase.attendeeName?.includes('+ 2')
                            ? { 'margin-left': '50px' }
                            : eachTouchbase.attendeeName?.includes('+ 3')
                                ? { 'margin-left': '65px' }
                                : {};
            return (
                <>
                    {i === 0 ? <label className="tt-bold font-16 mb-2">{date}</label> : null}
                    <ul className="list-unstyled align-middle">
                        <li className={View ? `bg-white profile-touchbase-panel mt-2` : `bg-white touchbase-tile px-4 mt-2`}>
                            <ul className="list-unstyled d-flex justify-content-between align-items-center">
                                <li
                                    title={eachTouchbase.title}
                                    onClick={
                                        eachTouchbase.status === 'Delayed' || eachTouchbase.status === 'Completed'
                                            ? () => {
                                                touchbaseFeedback(eachTouchbase.id);
                                            }
                                            : null
                                    }
                                    className={
                                        eachTouchbase.status === 'Delayed' || eachTouchbase.status === 'Completed'
                                            ? `bold-text touchbase-text-width text-truncate fontsize cursor`
                                            : `bold-text touchbase-text-width text-truncate fontsize`
                                    }
                                >
                                    <span>
                                        <img src="/Images/stopwatch.svg" className="me-2 " alt="icon" />
                                    </span>
                                    {eachTouchbase.title}
                                </li>
                                <li
                                    title={eachTouchbase.attendeeName?.includes('+') ? eachTouchbase.showData : eachTouchbase.attendeeName}
                                    className="bold-text touchbase-time-color font-15  touchbase-users-width text-truncate"
                                >
                                    <span>
                                        {eachTouchbase.type === 'team' ? (
                                            <img src="/Images/group-of-people.svg" className="touchbase-team-profile me-2" alt="icon" />
                                        ) : eachTouchbase.attendeeName?.includes('+ 1') ? (
                                            <img
                                                src="/Images/logo-person-user-person-icon.jpg"
                                                className="touchbase-user-profile touchbase-multiple-user user-img1"
                                                alt="icon"
                                            />
                                        ) : eachTouchbase.attendeeName?.includes('+ 2') ? (
                                            <>
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    className="touchbase-user-profile touchbase-multiple-user user-img1"
                                                    alt="icon"
                                                />
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    className="touchbase-user-profile touchbase-multiple-user user-img2"
                                                    alt="icon"
                                                />
                                            </>
                                        ) : eachTouchbase.attendeeName?.includes('+ 3') ? (
                                            <>
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    className="touchbase-user-profile touchbase-multiple-user user-img1"
                                                    alt="icon"
                                                />
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    className="touchbase-user-profile touchbase-multiple-user user-img2"
                                                    alt="icon"
                                                />
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    className="touchbase-user-profile touchbase-multiple-user user-img3"
                                                    alt="icon"
                                                />
                                            </>
                                        ) : (
                                            <img
                                                src="/Images/logo-person-user-person-icon.jpg"
                                                className="touchbase-user-profile me-2"
                                                alt="icon"
                                            />
                                        )}
                                    </span>
                                    <span style={customstyle}>{eachTouchbase.attendeeName}</span>
                                </li>
                                <li className="medium-text touchbase-time-color font-15 touchbase-users-width text-truncate ">
                                    {moment(eachTouchbase.start_time, ['h:mm A']).format('hh:mm A')} -{' '}
                                    {moment(eachTouchbase.end_time, ['h:mm A']).format('hh:mm A')}{' '}
                                </li>
                                <li>
                                    <ul className="list-unstyled d-flex">
                                        <li className={`status-btn ${eachTouchbase.color} font-12 me-3`}>{eachTouchbase.status}</li>
                                        {eachTouchbase.created_by_id === userDetails.roleId && eachTouchbase.status !== 'Completed' ? (
                                            <>
                                                <button
                                                    type="button "
                                                    className="btn p-0 align-top shadow-none"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <img src="/Images/kebab-menu.svg" />
                                                </button>
                                                <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm touchbase-dropdown-action">
                                                    <li
                                                        onClick={() => {
                                                            touchbaseEditClicked(eachTouchbase.id, eachTouchbase.type);
                                                        }}
                                                    >
                                                        <a className="dropdown-item dditems semibold-text font-12 touchbase-kebabitems-color">
                                                            <span>
                                                                <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                            </span>
                                                            Edit
                                                        </a>
                                                    </li>
                                                    <li
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#TouchbaseDelete"
                                                        onClick={() => {
                                                            setTouchbaseId(eachTouchbase.id);
                                                        }}
                                                    >
                                                        <a className="dropdown-item dditems semibold-text font-12 touchbase-kebabitems-color">
                                                            <span>
                                                                <img className="pe-2" src="/Images/hive-delete-icon.svg" />
                                                            </span>
                                                            Delete
                                                        </a>
                                                    </li>
                                                </ul>
                                            </>
                                        ) : null}
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </>
            );
        });
    };

    return (
        <>
            <Popup
                deleteData={() => {
                    touchbaseDeleteClicked();
                }}
                ID={'TouchbaseDelete'}
            />
            {insertToast ? <EvaluationPopUp color={ToastColor} Page={'Success Insert'} Heading={ToastValue} Paragraph={ToastPara} /> : null}
            {isLoading ? (
                <div className={View ? `container-fluid` : `container-fluid mt-5`}>
                    <div className="row justify-content-center mt-2">
                        <div className={View ? `col-md-12` : `col-md-10`}>
                            {View ? null : (
                                <div className="mt-4" style={{ 'margin-left': '-12px' }}>
                                    <BreadCrumbs data={breadCrumbsData} />
                                </div>
                            )}
                            <div className="d-flex justify-content-between mb-4 align-items-center">
                                <label className="tt-bold font-15 ">Touchbase</label>
                                <div className="d-flex">
                                    {/*Filter Section Starts Here*/}
                                    <div className="dropdown">
                                        <button
                                            className="advanced-filter-button custom-padding me-3 medium-text"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                            Filter
                                        </button>
                                        <div
                                            className="dropdown-menu px-3 advanced-filter-panel custom-filter-button"
                                            aria-labelledby="dropdownMenuButton1"
                                        >
                                            <div className="row">
                                                <div className="col-md-12 py-2 border-0 mb-1">
                                                    <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                                    <button
                                                        type="button"
                                                        className="btn-close float-end close-filter"
                                                        data-bs-dismiss="advanced-filter"
                                                        aria-label="Close"
                                                    />
                                                </div>
                                                <div className="col-md-12 ">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="Leave_type">
                                                            Status
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            onChange={(e) => {
                                                                filterOnChange(e);
                                                            }}
                                                            name="filterStatus"
                                                            id="Leave_type"
                                                            value={filter.filterStatus}
                                                        >
                                                            <option value="" selected>
                                                                Select
                                                            </option>
                                                            <option value={3}>Completed</option>
                                                            <option value={2}>Delayed</option>
                                                            <option value={1}>Yet to start</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-12 pb-2 border-0 ">
                                                        <span className="font-14 semibold-text filter-title">Date Range</span>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="fromrange">
                                                                From
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control hive-form-control"
                                                                id="fromrange"
                                                                name="filterFromDate"
                                                                max={filter.filterToDate}
                                                                value={filter.filterFromDate}
                                                                onChange={(e) => {
                                                                    filterOnChange(e);
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="forange">
                                                                To
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control hive-form-control"
                                                                id="forange"
                                                                name="filterToDate"
                                                                min={filter.filterFromDate}
                                                                value={filter.filterToDate}
                                                                onChange={(e) => {
                                                                    filterOnChange(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 my-3 d-flex justify-content-end">
                                                    <button
                                                        className="btn hive-btn-secondary me-3"
                                                        onClick={() => {
                                                            touchbaseClearClick();
                                                        }}
                                                    >
                                                        Clear
                                                    </button>
                                                    <button
                                                        className="btn hive-btn-primary"
                                                        onClick={() => {
                                                            touchbaseFilterClick();
                                                        }}
                                                    >
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*Filter Section Ends Here*/}
                                    <div className="dropdown">
                                        {(
                                            View && IsTeamMember
                                                ? null
                                                : (userDetails.role === 'Manager' || userDetails.role === 'Hr Manager') &&
                                                props.EmployeeStatus != 'Inactive'
                                        ) ? (
                                            <button
                                                className="btn hive-btn-primary font-12 dropdown-toggle medium-text"
                                                id="schedule-touchbase"
                                                data-bs-toggle="dropdown"
                                                data-bs-display="static"
                                                aria-expanded="false"
                                            >
                                                <img src="/Images/hive-add-icon.svg" alt="add-icon" className="me-2" />
                                                Schedule a Touchbase{' '}
                                            </button>
                                        ) : null}
                                        <ul
                                            className="dropdown-menu touchbase-dropdown shadow border-0 w-100"
                                            aria-labelledby="schedule-touchbase"
                                        >
                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    type="button"
                                                    onClick={() => {
                                                        newTouchbase('team');
                                                    }}
                                                >
                                                    Team Touchbase
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    type="button"
                                                    onClick={() => {
                                                        newTouchbase('individual');
                                                    }}
                                                >
                                                    Individual Touchbase
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/*Touchbase details section starts here*/}
                            <div className="mt-5">
                                {nodata ? (
                                    <div className="row justify-content-center">
                                        <img
                                            src="/Images/nodatafound.png"
                                            alt="nodatafound"
                                            className="nofeedbackimg-sty"
                                            style={{ height: '500px', width: '750px' }}
                                        />
                                        <h2 className="tt-bold font-15 text-center">No touchbase Found</h2>
                                    </div>
                                ) : null}

                                {!nodata
                                    ? Object.keys(touchbase).map((key, i) => {
                                        return bindTouchbase(touchbase[key], key);
                                    })
                                    : null}
                                {/* : null } */}
                            </div>
                            {/*Touchbase details section starts here*/}
                        </div>
                        <div className="text-center pb-3">
                            {showMore ? (
                                <button
                                    className="btn show-more-btn"
                                    onClick={() => {
                                        touchbaseShowMore();
                                    }}
                                >
                                    Show More
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            ) : (
                <Loader isLoading={isLoading} />
            )}
        </>
    );
}
